
export const generateNavigation = (user) => {
    const baseNavigation = [
        { code: 'HOME', text: 'Home', path: '/home', icon: 'home' },
        { code: 'HOME_CALLCENTER', text: 'Home', path: '/richiesteCallCenter', icon: 'tel' },
        { code: 'FLUSSO_APPROVATIVO', text: 'Flusso approvativo', path: '/flussoAppprovativo', icon: 'home' },
        { code: 'IMPIANTI', text: 'Impianti', path: '/elencoImpianti', icon: 'globe' },
        { code: 'RICHIESTE_INT', text: 'Richieste interventi', path: '/richiesteIntervento', icon: 'tel' },
        { code: 'RICHIESTE_PREV', text: 'Richieste preventivi', path: '/richiestePreventivi', icon: 'money' },
        { code: 'CONSULTAZIONE', text: 'Consultazione', icon: 'folder', items: [] },
        { code: 'DOCUMENTI', text: 'Documenti', path: '/documenti', icon: 'doc' },
        { code: 'FORUM', text: 'Messaggi', path: '/forum', icon: 'help' },
        { code: 'IVULCANOSMART', text: 'iVulcanoSmart', path: '/iVulcanoSmart', icon: 'link' },
        { code: 'PROFILO', text: 'Profilo', path: '/profile', icon: 'user' },
        { code: 'MANUALE', text: 'Manuale', path: '/manuale', icon: 'help' },
    ];

    const navigation = [];

    if (user.userType === 0) {  // CLIENTI
        navigation.push(baseNavigation[baseNavigation.findIndex(item => item.code === 'HOME')]);
        navigation.push(baseNavigation[baseNavigation.findIndex(item => item.code === 'IMPIANTI')]);
        navigation.push(baseNavigation[baseNavigation.findIndex(item => item.code === 'RICHIESTE_INT')]);
        navigation.push(baseNavigation[baseNavigation.findIndex(item => item.code === 'RICHIESTE_PREV')]);

        if (user.reeAllowed || user.letAllowed) {
            navigation.push(baseNavigation[baseNavigation.findIndex(item => item.code === 'CONSULTAZIONE')]);

            if (user.reeAllowed) {
                if (baseNavigation.findIndex(item => item.code === 'CONSULTAZIONE') > -1) baseNavigation[baseNavigation.findIndex(item => item.code === 'CONSULTAZIONE')].items.push({ code: 'REE', text: 'R.E.E.', path: '/ree', icon: 'favorites' });
            }

            if (user.letAllowed) {
                if (baseNavigation.findIndex(item => item.code === 'CONSULTAZIONE') > -1) baseNavigation[baseNavigation.findIndex(item => item.code === 'CONSULTAZIONE')].items.push({ code: 'CONSUMI', text: 'Consumi', path: '/ConsumiImpianto', icon: 'money' });
            }
        }

        if (user.docAllowed && user.isOmologato) {
            navigation.push(baseNavigation[baseNavigation.findIndex(item => item.code === 'DOCUMENTI')]);
            navigation.push(baseNavigation[baseNavigation.findIndex(item => item.code === 'FORUM')]);
        }


        if (user.mobileAllowed) {
            navigation.push(baseNavigation[baseNavigation.findIndex(item => item.code === 'IVULCANOSMART')]);
        }

        navigation.push(baseNavigation[baseNavigation.findIndex(item => item.code === 'MANUALE')]);
    }
    else if (user.userType === 1) { // ATTORI

        navigation.push(baseNavigation[baseNavigation.findIndex(item => item.code === 'HOME')]);

        if (user.docAllowed && user.isOmologato) {
            navigation.push(baseNavigation[baseNavigation.findIndex(item => item.code === 'DOCUMENTI')]);
            navigation.push(baseNavigation[baseNavigation.findIndex(item => item.code === 'FORUM')]);
        }


        if (user.mobileAllowed) {
            navigation.push(baseNavigation[baseNavigation.findIndex(item => item.code === 'IVULCANOSMART')]);
        }
        navigation.push(baseNavigation[baseNavigation.findIndex(item => item.code === 'PROFILO')]);
        navigation.push(baseNavigation[baseNavigation.findIndex(item => item.code === 'MANUALE')]);

    }
    else if (user.userType === 2) {  // AMMINISTRATORI
        navigation.push(baseNavigation[baseNavigation.findIndex(item => item.code === 'HOME')]);
        navigation.push(baseNavigation[baseNavigation.findIndex(item => item.code === 'IMPIANTI')]);
        navigation.push(baseNavigation[baseNavigation.findIndex(item => item.code === 'RICHIESTE_INT')]);
        navigation.push(baseNavigation[baseNavigation.findIndex(item => item.code === 'RICHIESTE_PREV')]);

        if (user.reeAllowed || user.letAllowed) {
            navigation.push(baseNavigation[baseNavigation.findIndex(item => item.code === 'CONSULTAZIONE')]);

            if (user.reeAllowed) {
                if (baseNavigation.findIndex(item => item.code === 'CONSULTAZIONE') > -1) baseNavigation[baseNavigation.findIndex(item => item.code === 'CONSULTAZIONE')].items.push({ code: 'REE', text: 'R.E.E.', path: '/ree', icon: 'favorites' });
            }

            if (user.letAllowed) {
                if (baseNavigation.findIndex(item => item.code === 'CONSULTAZIONE') > -1) baseNavigation[baseNavigation.findIndex(item => item.code === 'CONSULTAZIONE')].items.push({ code: 'CONSUMI', text: 'Consumi', path: '/ConsumiImpianto', icon: 'money' });
            }
        }

        if (user.docAllowed && user.isOmologato) {
            navigation.push(baseNavigation[baseNavigation.findIndex(item => item.code === 'DOCUMENTI')]);
            navigation.push(baseNavigation[baseNavigation.findIndex(item => item.code === 'FORUM')]);
        }
        
        if (user.mobileAllowed) {
            navigation.push(baseNavigation[baseNavigation.findIndex(item => item.code === 'IVULCANOSMART')]);
        }
        navigation.push(baseNavigation[baseNavigation.findIndex(item => item.code === 'PROFILO')]);
        navigation.push(baseNavigation[baseNavigation.findIndex(item => item.code === 'MANUALE')]);
    }
    else if (user.userType === 3) { // UTENTI FLUSSO APPROVATIVO
        navigation.push(baseNavigation[baseNavigation.findIndex(item => item.code === 'FLUSSO_APPROVATIVO')]);
    }
    else if (user.userType === 4) { // CALLCENTER
        navigation.push(baseNavigation[baseNavigation.findIndex(item => item.code === 'HOME_CALLCENTER')]);
        navigation.push(baseNavigation[baseNavigation.findIndex(item => item.code === 'MANUALE')]);
    }

    return navigation.filter(item => item.items?.length !== 0 || !item.items);
};